import { message } from 'antd';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import { logOut } from '../authentication/actionCreator';
import { getItem } from '../../utility/localStorageControl';

const {
  productAddBegin,
  productAddSuccess,
  productAddErr,

  productUpdateSuccess,
  productUpdateErr,
  productUpdateBegin,

  productReadBegin,
  productReadSuccess,
  productReadErr,

  productDeleteSuccess,
  productDeleteErr,
  productDeleteBegin,


} = actions;


const productDataSubmit = (data) => {
  return async (dispatch) => {
    try {
      await dispatch(productAddBegin());
      const response = await DataService.post('/product/create', data);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(productAddSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(productAddSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(productAddSuccess(null));
          dispatch(logOut());
        }
      }
    } catch (err) {
      await dispatch(productAddErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};




const productDataRead = () => {
  return async (dispatch) => {
    try {
      await dispatch(productReadBegin());
      const response = await DataService.get(`/product`);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(productReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(productReadSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(productReadSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(productReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};



const productDataUpdate = (data) => {
  return async (dispatch) => {
    try {
      await dispatch(productUpdateBegin());
      const response = await DataService.put(`/product/update`, data);

      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(productUpdateSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(productUpdateSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(productUpdateSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(productUpdateErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const productDataDelete = (id) => {
  return async (dispatch) => {
    try {
      await dispatch(productDeleteBegin());
      const response = await DataService.delete(`/product/delete/${id}`);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(productDeleteSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(productDeleteSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(productDeleteSuccess(null));
          dispatch(logOut());
        }
      }
    } catch (err) {
      await dispatch(productDeleteErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};




export {

  productDataSubmit,
  productDataUpdate,
  productDataRead,
  productDataDelete
};
